module.exports = __webpack_public_path__ + "static/img/SUP_PHOTO_RF.1f27974.jpg";